<!-- [hidden] (not *ngIf) here only ever hides the input box. The modal below is
     deliberately OUTSIDE this block — a parent hiding the field while an
     authorization check runs (verifyPatientId/gatePatient) must never also
     hide the modal that check may need to pop. -->
<div [hidden]="hideField">
  <div class="input-group flex-control" style="overflow: visible;">
    <input [(ngModel)]="asyncSelected" [typeaheadAsync]="true"
           [typeaheadItemTemplate]="patientAuthorizeItemTemplate"
           typeaheadWaitMs="500"
           [typeahead]="dataSourcePatients"
           (typeaheadLoading)="changeTypeaheadLoading($event)"
           autocomplete="off"
           (typeaheadNoResults)="changeTypeaheadNoResults($event)"
           (typeaheadOnSelect)="typeaheadOnSelect($event)"
           [typeaheadOptionsLimit]="7"
           [typeaheadOptionField]="'complete_detail'"
           [placeholder]="placeholder"
           [name]="name" [class]="inputClass">

    <div class="updox-compose-patient-spinner input-group-addon" style="right: 170px; border:none; background:transparent; padding:0; " *ngIf="typeaheadLoading"><i class="fa fa-spinner fa-spin"></i></div>
    <a class="btn btn-secondary btn-outline pointer ml-lg fs12" style="border-color: #2d79e8;"
       (click)="openAddPatient()"><i class="fa fa-plus mr-sm"></i>Add New Patient</a>

  </div>
  <div *ngIf="typeaheadNoResults" class="text-danger fs13">No Results Found!</div>
</div>

<ng-template #patientAuthorizeItemTemplate let-model="item" let-index="index" let-query="query">
  <!-- Selection itself is handled by (typeaheadOnSelect) on the input below;
       this template only controls how each dropdown row renders. -->
  <div>
    <span [ngClass]="isAuthorized(model) ? 'text-black' : 'text-orange'"
          [innerHTML]="highlightQuery(model.complete_detail, query)"></span>
  </div>
</ng-template>

<div class="modal modal_popup" bsModal #authorizationModal="bs-modal" [config]="{backdrop: false, ignoreBackdropClick: true}">
  <div class="modal-dialog modal-lg" style="height:500px;">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" (click)="hideModal();"><i class="fa fa-times fs16"></i></button>
        <h4 class="m0 text-center">Patient Authorization Required</h4>
      </div>
      <div class="modal-body">
        <p class="alert alert-danger p">
          <i class="fa fa-exclamation-triangle mr-sm"></i>
          You are not authorized to access this patient record, please get authorization from patient via Text Message or KBA.
        </p>
        <div class="clearfix">
          <span class="fs18 mr-lg vl-m">Authorize by</span>
          <button (click)="chooseAuthType('sms')" class="btn btn-primary"><i class="fa fa-mobile-phone fs20 mr-sm"></i> Text Message</button>
          <span class="mr-lg ml-lg vl-m">OR</span>
          <button (click)="chooseAuthType('kba')" class="btn btn-primary"><i class="fa fa-file-text-o mr-sm"></i> KBA</button>
        </div>
        <div class="p-lg" *ngIf="authType == 'sms'">
          <h4 class="fs22"><i class="fa fa-mobile-phone mr-sm"></i> Text Message Authorization</h4>
          <p class="text-success mb-lg">Message has been sent. Please ask your patient to provide Verification.</p>
          <div class="row">
            <div class="col-sm-6 col-xs-12 form-group">
              <form (ngSubmit)="verifyOtp()" #PhoneForm="ngForm">
                <label>Mobile Verification*</label>
                <div class="input-group">
                  <input type="text" name="mobile_otp" class="form-control" [(ngModel)]="otp" required #mobile_otp/>
                  <span class="input-group-btn">
                    <button class="btn btn-primary" *ngIf="!verified" type="submit" [disabled]="!PhoneForm.form.valid || isVerifying">
                      <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isVerifying"></i>
                      <i class="fa fa-check-circle mr-sm" *ngIf="!isVerifying"></i> Verify
                    </button>
                    <button class="btn btn-success" type="button" *ngIf="verified"><i class="fa fa-check mr-sm"></i> Verified</button>
                  </span>
                </div>
                <p [ngClass]="messageClass">{{mobileMessage}}</p>
              </form>
            </div>
          </div>
          <h5 class="m0 mb-sm">
            <a class="btn-link" (click)="resendOtp()"><i class="fa fa-share-square"></i> Resend</a>
          </h5>
          <p class="m0 fs12">If you haven't received the Mobile Verification within one minute, click <span class="text-primary">"Resend"</span></p>
          <p [ngClass]="messageClass" *ngIf="authType == 'sms'">{{generalMessage}}</p>
        </div>
        <div class="p-lg" *ngIf="authType == 'kba'">
          <h4 class="fs22"><i class="fa fa-file-text-o mr-sm"></i> KBA Authorization</h4>
          <p class="text-success mb-lg">Please ask for Patient's Mother Name given at time of Registration.</p>
          <div class="row">
            <div class="col-sm-6 col-xs-12 form-group">
              <form (ngSubmit)="verifyMotherName()" #MotherForm="ngForm">
                <label>Mother's Maiden Name*</label>
                <div class="input-group">
                  <input type="text" name="mother_name" class="form-control" [(ngModel)]="motherName" maxlength="15" pattern="[^\s]+" required/>
                  <span class="input-group-btn">
                    <button *ngIf="!verified" type="submit" class="btn btn-primary" [disabled]="!MotherForm.form.valid || isVerifying">
                      <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isVerifying"></i>
                      <i class="fa fa-check-circle mr-sm" *ngIf="!isVerifying"></i> Verify
                    </button>
                    <button class="btn btn-success" type="button" *ngIf="verified"><i class="fa fa-check mr-sm"></i> Verified</button>
                  </span>
                </div>
                <p class="text-muted mt-sm fs12">{{hint}}</p>
                <p [ngClass]="messageClass">{{mobileMessage}}</p>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer mt-lg">
        <button class="btn btn-secondary" [disabled]="!verified" (click)="onContinue()">Continue</button>
        <button type="button" class="btn btn-tertiary btn-outline" (click)="hideModal();">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Add New Patient — same DemographicsComponent form used on the patient
     listing page's "Add" popup, prefilled with addPatientPrefill when set. -->
<div class="modal modal_popup" bsModal #addPatientModal="bs-modal" [config]="{backdrop: false}">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" (click)="closeAddPatient()"><i class="fa fa-times fs16"></i></button>
        <h4 class="m0 text-center">Add New Patient</h4>
      </div>
      <div class="modal-body">
        <app-demographics [show_extras]="true" [patient]="newPatient" [skipMobileRequired]="true"
                           (new_user)="onNewPatientCreated($event)"></app-demographics>
      </div>
    </div>
  </div>
</div>
